import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt"
import type { Draw, DrawMap, DrawOptions } from "leaflet"
import type { ReactElement } from "react"
import "leaflet-arrowheads"
import { useTranslation } from "react-i18next"
import { DrawShapeControl } from ".."
import { MapViewerPanel } from "../../../redux"
import { PolylineDrawOverwrite } from "../../../utils"

export function DrawArrowControl(): ReactElement {
  const { t } = useTranslation("map")

  function createArrowFeature(map: DrawMap): Draw.Feature {
    const options: DrawOptions.PolylineOptions = {
      shapeOptions: {
        color: "#000000",
        dashArray: ""
      },
      maxPoints: 2
    }
    return new PolylineDrawOverwrite(map, options)
  }

  return (
    <DrawShapeControl
      controlPanel={MapViewerPanel.DrawArrow}
      tooltip={t("actionButtons.edit.arrow")}
      icon={<ArrowRightAltIcon />}
      createFeature={createArrowFeature}
    />
  )
}
